import { Globe, Award, ShieldCheck, HeadphonesIcon } from 'lucide-react';
import { motion } from 'framer-motion';

const features = [
  {
    icon: Globe,
    title: 'Nationwide Coverage',
    description: 'Coast-to-coast service across all 48 contiguous states',
  },
  {
    icon: Award,
    title: 'Specialized Expertise',
    description: 'Years of experience in heavy equipment and freight logistics',
  },
  {
    icon: ShieldCheck,
    title: 'Reliable & Transparent',
    description: 'No hidden fees, real-time tracking, and proactive communication',
  },
  {
    icon: HeadphonesIcon,
    title: 'Dedicated Support',
    description: 'A single point of contact who knows your freight needs',
  },
];

export const WhyChooseUs = () => {
  return (
    <section data-testid="why-choose-us-section" className="py-20 lg:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-navy-900 uppercase"
          >
            Why Choose Summit Transport & Logistics
          </motion.h2>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              data-testid={`feature-card-${index}`}
              className="flex flex-col items-center text-center group"
            >
              <div className="w-24 h-24 lg:w-28 lg:h-28 rounded-full bg-white border-2 border-slate-200 flex items-center justify-center mb-6 shadow-md group-hover:border-orange-500 group-hover:shadow-lg transition-all duration-300">
                <feature.icon className="w-10 h-10 lg:w-12 lg:h-12 text-navy-900 group-hover:text-orange-500 transition-colors duration-300" />
              </div>
              <h3 className="font-heading text-lg lg:text-xl font-bold text-navy-900 uppercase mb-2">
                {feature.title}
              </h3>
              <p className="font-body text-sm text-slate-600 leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
